module.exports = __webpack_public_path__ + "img/11-EnterpriseConnect.e81cef29.jpg";